import uniqid from 'uniqid';
import i18n from '@/common/i18n';
import { NotificationType } from '@/common/constants/notifications.constants';

interface Error {
  id: string,
    title: string,
    message: string
}

interface ErrorsState {
  errors: Error[]
}

const initialState: ErrorsState = {
  errors: []
};

const errorsMutations: CommonMutationTree<ErrorsState> = {
  ADD_ERROR(state, error) {
    if (process.env.NODE_ENV === 'development') state.errors = [...state.errors, error];
  },
  FLUSH_STATE(state) {
    state.errors = [];
  }
};

const errorsActions: CommonActionTree<ErrorsState> = {
  ADD_ERROR({ commit, dispatch }, error): void {
    const newError = { id: uniqid('notification_'), ...error };
    // TODO normalize error
    commit('ADD_ERROR', newError);

    dispatch('notifications/ADD', {
      type: NotificationType.ERROR,
      title: error.title || i18n.t('Generic error'),
      message: error.message
    }, { root: true });
  }
};

export default new class implements CommonStore<ErrorsState, unknown> {
  name = 'errors';
  namespaced = true;
  state = initialState;
  mutations = errorsMutations;
  actions = errorsActions;
}();
